import { useParams } from 'react-router'
import type { TJournalUrlParams } from '@/types/Journal'

export const useJournalUrlParams = () => useParams<TJournalUrlParams>()
